import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { CompleteEmailAccountSetupDto, ForgotPasswordDto, LoginDto, LoginResponseDto, ResetPasswordDto } from '../common/dto/auth.dto';
import { StatusDto } from '../common/dto/common.dto';
import { RootState } from '../redux/store';
import { getBrowserName } from '../utils/browser.utils';
import { currentVersion, versionAsNumber } from './utils';

const API_URI = import.meta.env.VITE_UAA_SERVICE;

// TODO apis on this side should not expect token as its publick
export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${API_URI}/auth/`,
    prepareHeaders: (headers, { getState }) => {
      headers.set('app-platform', 'Web');
      headers.set('app-platform-client', getBrowserName());
      const { accessToken } = (getState() as RootState).tokens;
      headers.set('Authorization', `Bearer ${accessToken}`);
      headers.set('x-version-name', currentVersion);
      headers.set('x-version-code', versionAsNumber.toString());
      return headers;
    },
  }),

  tagTypes: ['Login', 'ForgotPassword', 'ResetPassword'],
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponseDto, Partial<LoginDto>>({
      query(body) {
        return {
          url: `login`,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: [{ type: 'Login', id: 'LIST' }],
    }),

    forgotPassword: builder.mutation<StatusDto, Partial<ForgotPasswordDto>>({
      query(body) {
        return {
          url: `forgot-password`,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: [{ type: 'ForgotPassword' }],
    }),
    resetPassword: builder.mutation<StatusDto, Partial<ResetPasswordDto>>({
      query(body) {
        return {
          url: `reset-password`,
          method: 'POST',
          body,
        };
      },
    }),
    validateCompleteAccountSetupKey: builder.mutation<StatusDto, Partial<{ key: string }>>({
      query(body) {
        return {
          url: `validate-complete-account-setup-key`,
          method: 'PATCH',
          body,
        };
      },
    }),
    completeAccountSetup: builder.mutation<StatusDto, Partial<CompleteEmailAccountSetupDto>>({
      query(body) {
        return {
          url: `complete-account-setup`,
          method: 'POST',
          body,
        };
      },
    }),
    validateForgotPasswordKey: builder.mutation<StatusDto, Partial<{ key: string }>>({
      query(body) {
        return {
          url: `validate-forgot-password-key`,
          method: 'PATCH',
          body,
        };
      },
    }),
  }),
});

// auto-generated based on the defined endpoints
export const {
  useLoginMutation,
  useForgotPasswordMutation,
  useValidateCompleteAccountSetupKeyMutation,
  useResetPasswordMutation,
  useCompleteAccountSetupMutation,
  useValidateForgotPasswordKeyMutation,
} = authApi;
